/**
 * Le jeu du « Défi éclair », partagé par le défi de l'attente de correction (`<CorrectionChallenge>`)
 * et le quiz de fin de séance (`<StudentLiveQuizPage>`) : ses mots, l'état de chaque réponse une fois
 * la question répondue, et le seuil de la série. Sans rien de React Native : les textes du quiz de
 * fin de séance s'en servent et se testent seuls.
 */
import { type QuizChoiceState } from "../../molecules/QuizChoiceRow"

/** La série ne se montre qu'à partir de deux bonnes réponses d'affilée — comme aujourd'hui. */
export const CHALLENGE_STREAK_FROM = 2

export const CHALLENGE_GAME_TEXTS = {
    count: (index: number, total: number) => `${index + 1} / ${total}`,
    streak: (n: number) => `Série x${n}`,
    score: (right: number, total: number) => `${right} sur ${total}`,
    right: "Bien joué !",
    wrong: "Pas tout à fait : la bonne réponse est en vert.",
    next: "Question suivante",
    seeScore: "Voir mon score",
}

/** Une réponse, la question répondue ou pas : la bonne en vert, la choisie à tort en rouge, les autres éteintes. */
export function challengeChoiceState(index: number, correctIndex: number, selected: number | null): QuizChoiceState {
    if (selected == null) return "idle"
    if (index === correctIndex) return "right"
    if (index === selected) return "wrong"
    return "inert"
}
